export class OutageModel {
  public mode: 'info' | 'error' | 'important' | '' = '';
  public icon = '';
  public guid = '';
  public type = '';
  public description = '';
  public expiry = '';
  public viewIndex;

  constructor(init?: Partial<OutageModel>) {
    Object.assign(this, init);
  }
}
